export default __webpack_public_path__ + "images/2I.f16d074.png";